module.exports = __webpack_public_path__ + "img/PEA.3ce80327.jpg";